import React from 'react';
import './LoadingIcon.css';

const LoadingIcon = () => {
  return (
    <div className="loading-overlay">
        <div className="loading-icon"></div>
    </div>
  );
};

export default LoadingIcon;